module.exports = __webpack_public_path__ + "img/01-T.f58476f3.png";